// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GAlW","label":"styles_label__2e24r"};